import React from "react";
import styles from "./styles.css";
import { FESTIVAL_BANNER_IMAGE, FESTIVAL_BANNER_TEXT_IMAGE } from "./constants";
import SearchRevamp from "../search-revamp";
import { Helmet } from "react-helmet";

const FestivalBanner = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="preload" href={FESTIVAL_BANNER_IMAGE} as={"image"} type="image/jpg" />
            </Helmet>
            <div styleName={"styles.wrapper"}>
                <img src={FESTIVAL_BANNER_IMAGE} alt="Egg-citing deals await" />
                <div styleName={"styles.contentWrapper"}>
                    <div className="container">
                        <div styleName={"styles.textWrap"}>
                            <img src={FESTIVAL_BANNER_TEXT_IMAGE} alt="Use code EASTER300 for a $300 discount" />
                        </div>
                        <div styleName={"styles.outer"}>
                            <SearchRevamp isHomePage={true} />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default FestivalBanner;
